(function ($) {
  Drupal.behaviors.r4_reviews_slide = {
    attach: function (context, settings) {
      $('#r4_mod3', context).once('r4_reviews_slide', function () {
        /* FLARES */
        // Animating the Flares.
        var flareInit1 = new TimelineMax({
          repeat: -1
        });
        var flare1 = $('#r4_reviews_flare_1');

        flareInit1.set(flare1, {
          opacity: '0.8'
        });
        flareInit1.to(flare1, 3, {
          opacity: .1
        });
        flareInit1.to(flare1, 2, {
          opacity: 0.7
        });

        var flareInit2 = new TimelineMax({
          repeat: -1,
          delay: 2
        });
        var flare2 = $('#r4_reviews_flare_2');

        flareInit2.set(flare2, {
          opacity: '0.1'
        });
        flareInit2.to(flare2, 2, {
          opacity: 0.5
        });
        flareInit2.to(flare2, 1, {
          opacity: .35
        });

        var flareInit3 = new TimelineMax({
          repeat: -1
        });
        var flare3 = $('#r4_reviews_flare_3');

        flareInit3.set(flare3, {
          opacity: '.1'
        });
        flareInit3.to(flare3, 2, {
          opacity: .4
        });
        flareInit3.to(flare3, 1, {
          opacity: .2
        });

        var flareInit4 = new TimelineMax({
          repeat: -1
        });
        var flare4 = $('#r4_reviews_flare_4');

        flareInit4.set(flare4, {
          opacity: '0.8'
        });
        flareInit4.to(flare4, 3, {
          opacity: .5
        });

        var flareInit5 = new TimelineMax({
          repeat: -1
        });
        var flare5 = $('#r4_reviews_flare_5');

        flareInit5.set(flare5, {
          opacity: '.5'
        });
        flareInit5.to(flare5, 3, {
          opacity: 0.3
        });
        flareInit5.to(flare5, 2, {
          opacity: .7
        });

        var flareInit6 = new TimelineMax({
          repeat: -1
        });
        var flare6 = $('#r4_reviews_flare_6');

        flareInit6.set(flare6, {
          opacity: '.6'
        });
        flareInit6.to(flare6, 2, {
          opacity: .2
        });
        flareInit6.to(flare6, 2, {
          opacity: .7
        });

        var flareInit7 = new TimelineMax({
          repeat: -1,
          delay: 2
        });
        var flare7 = $('#r4_reviews_flare_7');

        flareInit7.set(flare7, {
          opacity: '.5'
        });
        flareInit7.to(flare7, 2, {
          opacity: 0.8
        });
        flareInit7.to(flare7, 1, {
          opacity: .2
        });

        var flareInit8 = new TimelineMax({
          repeat: -1
        });
        var flare8 = $('#r4_reviews_flare_8');

        flareInit8.set(flare8, {
          opacity: '.75'
        });
        flareInit8.to(flare8, 2, {
          opacity: 1
        });
        flareInit8.to(flare8, 3, {
          opacity: .6
        });
        flareInit8.to(flare8, 2, {
          opacity: .85
        });
        flareInit8.to(flare8, 1, {
          opacity: .4
        });

        var flareInit9 = new TimelineMax({
          repeat: -1
        });
        var flare9 = $('#r4_reviews_flare_9');

        flareInit9.set(flare9, {
          opacity: '.3'
        });
        flareInit9.to(flare9, 2, {
          opacity: .8
        });
        flareInit9.to(flare9, 1, {
          opacity: 0.2
        });
      });
    }
  };
})(jQuery);
